"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SvgIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var sizeMap = {
  small: 15,
  medium: 20,
  large: 25
};

function SvgIcon(_ref) {
  var children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      viewBox = _ref.viewBox,
      nodeRef = _ref.nodeRef,
      other = (0, _objectWithoutProperties2.default)(_ref, ["children", "color", "size", "style", "viewBox", "nodeRef"]);
  var resultSize = sizeMap[size] || size;
  var resultStyle = (0, _extends2.default)({
    width: resultSize,
    height: resultSize,
    display: 'inline-block',
    userSelect: 'none',
    fill: color
  }, style);
  var resultViewBox = typeof viewBox === 'function' ? viewBox(resultSize) : viewBox;
  var resultChildren = typeof children === 'function' ? children(resultSize) : children;
  return _react.default.createElement("svg", (0, _extends2.default)({}, other, {
    ref: nodeRef,
    viewBox: resultViewBox,
    style: resultStyle
  }), resultChildren);
}

SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Дополнительный класс для иконки
   */
  className: _propTypes.default.string,

  /**
   * Дополнительные инлайновые стили для иконки
   */
  style: _propTypes.default.object,

  /**
   * Цвет иконки
   */
  color: _propTypes.default.string,

  /**
   * Элементы, которые отрисуются внутри svg-элемента,
   * ожидается `ReactElement` или функция возвращающая его и получающая размер как аргумент `size => ReactElement`
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),

  /**
   * Размер иконки. Может быть строкой или значением в пикселях
   */
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['small', 'medium', 'large']), _propTypes.default.number, _propTypes.default.string]),

  /**
   * Атрибут viewBox svg-элемента
   * ожидается строка или функция возвращающая строку и получающая размер как аргумент `size => string`
   */
  viewBox: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Коллбэк для передачи ссылки на ноду svg элемента
   */
  nodeRef: _propTypes.default.func
} : {};
SvgIcon.defaultProps = {
  viewBox: '0 0 20 20',
  size: 'medium',
  style: {},
  color: 'black'
};